module.exports = __webpack_public_path__ + "img/add-icon.778ae355.svg";